module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "姓名"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.loadData
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "size": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticClass: "tb-edit",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.aData,
      "highlight-current-row": "",
      "height": "550",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "销项涉税规则维护",
      "align": "center",
      "width": "180"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "id",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.id))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "公司编码",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.companyCode),
            callback: function($$v) {
              _vm.$set(scope.row, "companyCode", $$v)
            },
            expression: "scope.row.companyCode"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.companyCode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "公司名称",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.companyName),
            callback: function($$v) {
              _vm.$set(scope.row, "companyName", $$v)
            },
            expression: "scope.row.companyName"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.companyName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "涉税规则编号",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.code),
            callback: function($$v) {
              _vm.$set(scope.row, "code", $$v)
            },
            expression: "scope.row.code"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.code))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "涉税规则名称",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.name),
            callback: function($$v) {
              _vm.$set(scope.row, "name", $$v)
            },
            expression: "scope.row.name"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "计税方式",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择计税方式"
          },
          model: {
            value: (scope.row.jsfs),
            callback: function($$v) {
              _vm.$set(scope.row, "jsfs", $$v)
            },
            expression: "scope.row.jsfs"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "免税",
            "value": "免税"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "一般计税",
            "value": "一般计税"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "简易计税",
            "value": "简易计税"
          }
        })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.jsfs))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否计税",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择是否计税"
          },
          model: {
            value: (scope.row.sfjs),
            callback: function($$v) {
              _vm.$set(scope.row, "sfjs", $$v)
            },
            expression: "scope.row.sfjs"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "是",
            "value": "是"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "否",
            "value": "否"
          }
        })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.sfjs))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否含税",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择是否含税"
          },
          model: {
            value: (scope.row.sfhs),
            callback: function($$v) {
              _vm.$set(scope.row, "sfhs", $$v)
            },
            expression: "scope.row.sfhs"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "是",
            "value": "是"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "否",
            "value": "否"
          }
        })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.sfhs))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "税率",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择税率"
          },
          model: {
            value: (scope.row.taxRate),
            callback: function($$v) {
              _vm.$set(scope.row, "taxRate", $$v)
            },
            expression: "scope.row.taxRate"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "0%",
            "value": "0%"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "3%",
            "value": "3%"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "6%",
            "value": "6%"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "10%",
            "value": "10%"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "16%",
            "value": "16%"
          }
        })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.taxRate))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否即征即退",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择是否即征即退"
          },
          model: {
            value: (scope.row.sfjzjt),
            callback: function($$v) {
              _vm.$set(scope.row, "sfjzjt", $$v)
            },
            expression: "scope.row.sfjzjt"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "是",
            "value": "是"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "否",
            "value": "否"
          }
        })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.sfjzjt))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "开票规则",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.kpgz),
            callback: function($$v) {
              _vm.$set(scope.row, "kpgz", $$v)
            },
            expression: "scope.row.kpgz"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.kpgz))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品及服务编码",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.goodsCode),
            callback: function($$v) {
              _vm.$set(scope.row, "goodsCode", $$v)
            },
            expression: "scope.row.goodsCode"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.goodsCode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品及服务名称",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.goodsName),
            callback: function($$v) {
              _vm.$set(scope.row, "goodsName", $$v)
            },
            expression: "scope.row.goodsName"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.goodsName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "纳税申报表行号",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.rowIndex),
            callback: function($$v) {
              _vm.$set(scope.row, "rowIndex", $$v)
            },
            expression: "scope.row.rowIndex"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.rowIndex))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "纳税申报表行名",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.tableName),
            callback: function($$v) {
              _vm.$set(scope.row, "tableName", $$v)
            },
            expression: "scope.row.tableName"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.tableName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否启用",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.isEnable),
            callback: function($$v) {
              _vm.$set(scope.row, "isEnable", $$v)
            },
            expression: "scope.row.isEnable"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.isEnable))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a07e86cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/D.vue
// module id = 722
// module chunks = 1